import { getMomentDate } from '../utils/commonUtils';
import { get, set } from 'lodash';
import { PAGINATION } from '../constants/Define';
import { OrderSurchargeItem } from './Order';

import RoomType from './RoomType';
import Hotel from './Hotel';

export default class Reservation {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data = {}) {
        this.id = data.id || undefined;
        this.itineraryNumber = data.itineraryNumber || undefined;
        this.operaConfirmationNumber = data.operaConfirmationNumber || undefined;
        this.arrivalDate = getMomentDate(data.arrivalDate, undefined, false);
        this.setRoomOccupancy(data);
        this.lengthOfStay = data.lengthOfStay || 0;
        this.setTotal(data);
        this.setRoomRate(data);
        this.setProfiles(data);
        this.setPackages(data);
        this.setComments(data);
        this.setHotelInfo(data);
        this.status = data.status || undefined;
        this.orderStatus = data.orderStatus || undefined;
        this.setDetail(data.surcharges || {});
        this.roomConfirmationNumber = data.roomConfirmationNumber || undefined;
        this.setMarkupBundle(data)
    }

    setMarkupBundle(data = {}) {
        this.markupPrice = (data.markupPrice || []).map(item => ({
            stayDate: item.stayDate || undefined,
            markupExchangeToCash: item.markupExchangeToCash || 0,
            markupValue: item.markupValue || undefined,
            type: item.type || undefined
        }))
    }

    setDetail(data = {}) {
        this.detail = {
            pageIndex: data.pageIndex || PAGINATION.pageIndex,
            pageSize: data.pageSize || PAGINATION.pageSize,
            totalCount: data.totalCount || 0,
            totalPage: Math.ceil(parseInt(data.totalCount || 0) / parseInt(data.pageSize || PAGINATION.pageSize)),
            orderBy: data.orderBy,
            orderByDesc: data.orderByDesc,
            items: (data.surcharges || []).map(item => new OrderSurchargeItem(item))
        }
    }

    setRoomOccupancy(data = {}) {
        this.roomOccupancy = data.roomOccupancy && new RoomOccupancy(data.roomOccupancy);
    }

    setTotal(data = {}) {
        this.total = data.total && {
            amount: data.total.amount && new Amount(data.total.amount),
            taxFeeItems: (data.total.taxFeeItems || []).map(item => new TaxFeeItem(item)),
        }
    }

    setRoomRate(data = {}) {
        this.roomRates = (data.roomRates || []).map(item => new RoomRate(item));
    }

    setProfiles(data = {}) {
        this.profiles = (data.profiles || []).map(item => new Profile(item));
    }

    setPackages(data = {}) {
        this.packages = (data.packages || []).map(item => new Package(item));
    }

    setComments(data = {}) {
        this.comments = (data.comments || []).map(item => new Comment(item));
    }

    setHotelInfo(data = {}) {
        this.hotelInfo = data.hotelInfo && new Hotel(data.hotelInfo);
    }

}

export class RoomOccupancy {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data = {}) {
        this.numberOfAdult = data.numberOfAdult || 0;
        this.numberOfChild = data.numberOfChild || 0;
        this.numberOfInfant = data.numberOfInfant || 0;
        this.setOtherOccupancies(data);
    }

    setOtherOccupancies(data = {}) {
        this.otherOccupancies = (data.otherOccupancies || []).map(item => new Occupancy(item))
    }

}

export class Occupancy {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data = {}) {
        this.otherOccupancyRefID = data.otherOccupancyRefID || undefined;
        this.otherOccupancyRefCode = data.otherOccupancyRefCode || undefined;
        this.quantity = data.quantity || 0;
    }
}

export class Amount {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data = {}) {
        this.amount = data.amount || 0;
        this.currencyCode = data.taxFeeItems || undefined;
    }
}

export class TaxFeeItem {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data = {}) {
        this.type = data.type || undefined;
        this.name = data.name || undefined;
        this.code = data.code || undefined;
        this.refID = data.refID || undefined;
        this.amount = data.amount && new Amount(data.amount);
        this.detail = data.detail || undefined;
    }
}

export class RoomRate {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data = {}) {
        this.stayDate = getMomentDate(data.stayDate, undefined, false);
        this.roomTypeRefID = data.roomTypeRefID || undefined;
        this.ratePlanCode = data.ratePlanCode || undefined;
        this.ratePlanName = data.ratePlanName || undefined;
        this.ratePlanRefID = data.ratePlanRefID || undefined;
        this.roomType = data.roomType && new RoomType(data.roomType)
        this.ratePlanInfo = data.ratePlanInfo && new RatePlanInfo(data.ratePlanInfo);
        this.amount = data.amount && new Amount(data.amount);
    }
}

export class RatePlanInfo {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data = {}) {
        this.ratePlanId = data.ratePlanId || undefined;
        this.ratePlanCategoryId = data.ratePlanCategoryId || undefined;
        this.marketId = data.marketId || undefined;
        this.sourceId = data.sourceId || undefined;
        this.rateCode = data.rateCode || undefined;
        this.name = data.name || undefined;
        this.description = data.description || undefined;
        this.shortDescription = data.shortDescription || undefined;
        this.beginSellDate = getMomentDate(data.beginSellDate, undefined, false);
        this.endSellDate = getMomentDate(data.endSellDate, undefined, false);
        this.maxAdult = data.maxAdult || 0;
        this.minAdult = data.minAdult || 0;
        this.maxChildren = data.maxChildren || 0;
        this.minChildren = data.minChildren || 0;
        this.minStayThru = data.minStayThru || 0;
        this.maxStayThru = data.maxStayThru || 0;
        this.minAdvanceBooking = data.minAdvanceBooking || 0;
        this.maxAdvanceBooking = data.maxAdvanceBooking || undefined;
        this.isTiered = data.isTiered || false;
        this.isBar = data.isBar || false;
        this.status = data.status || false;
        this.ratePlanGroupId = data.ratePlanGroupId || undefined;
        this.propertyId = data.propertyId || undefined;
        this.exchangeTypeId = data.exchangeTypeId || undefined;
        this.transactionCode = data.transactionCode || undefined;
        this.transactionCodeId = data.transactionCodeId || undefined;
        this.pkgTransactionCodeId = data.pkgTransactionCodeId || undefined;
        this.taxIncluded = data.taxIncluded || false;
        this.inheritType = data.inheritType || 0;
        this.baseRateModifyAmount = data.baseRateModifyAmount || 0;
        this.baseRateModifyUnitType = data.baseRateModifyUnitType || 0;
        this.baseRateModifyRoudingType = data.baseRateModifyRoudingType || 0;
        this.currency = data.currency || undefined;
        this.cancelPolicyId = data.cancelPolicyId || undefined;
        this.childPolicyId = data.childPolicyId || undefined;
        this.guaranteePolicyId = data.guaranteePolicyId || undefined;
        this.amendmentPolicyId = data.amendmentPolicyId || undefined;
        this.depositPolicyId = data.depositPolicyId || undefined;
        this.otherPolicyId = data.otherPolicyId || undefined;
        this.parentId = data.parentId || undefined;
        this.createdAt = getMomentDate(data.createdAt, undefined, false);
        this.updatedAt = getMomentDate(data.updatedAt, undefined, false);
        this.roomTypeIds = data.roomTypeIds || [];
        this.taxes = data.taxes || [];
        this.childPolicy = data.childPolicy && new Policy(data.childPolicy)
        this.amendmentPolicy = data.amendmentPolicy && new Policy(data.amendmentPolicy)
        this.cancelPolicy = data.cancelPolicy && new Policy(data.cancelPolicy)
        this.guaranteePolicy = data.guaranteePolicy && new Policy(data.guaranteePolicy)
        this.distributionChannels = data.distributionChannels || [];
        this.discountTypeCode = data.discountTypeCode || 0;
        this.discountTypeName = data.discountTypeName || undefined;
        this.includesBreakfast = data.includesBreakfast || false;
        this.includesLunch = data.includesLunch || false;
        this.includesDinner = data.includesDinner || false;
        this.isAdvDailyBaseRate = data.isAdvDailyBaseRate || false;
        this.isAdvDailyRate = data.isAdvDailyRate || false;
        this.isDailyRate = data.isDailyRate || false;
        this.isPublic = data.isPublic || false;
    }
}

export class Policy {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data = {}) {
        this.id = data.id || undefined;
        this.code = data.code || undefined;
        this.description = data.description || undefined;
        this.createdAt = getMomentDate(data.createdAt, undefined, false);
        this.updatedAt = getMomentDate(data.updatedAt, undefined, false);
        this.detail = data.detail || [];
    }
}

export class Profile {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data = {}) {
        this.profileRefID = data.profileRefID || undefined;
        this.email = data.email || undefined;
        this.firstName = data.firstName || undefined;
        this.middleName = data.middleName || undefined;
        this.lastName = data.lastName || undefined;
        this.title = data.title || undefined;
        this.phoneNumber = data.phoneNumber || undefined;
        this.profileType = data.profileType || undefined;
        this.passport = data.passport || undefined;
        this.passportExpiredDate = getMomentDate(data.email, undefined, false);
        this.gender = data.gender || undefined;
        this.address = data.address || undefined;
        this.city = data.city || undefined;
        this.state = data.state || undefined;
        this.country = data.country || undefined;
        this.nationality = data.nationality || undefined;
    }
}

export class Package {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data = {}) {
        this.usedDate = getMomentDate(data.usedDate, undefined, false);
        this.packageRefID = data.packageRefID || undefined;
        this.packageCode = data.packageCode || undefined;
        this.packageName = data.packageName || undefined;
        this.detail = data.detail || undefined;
        this.quantity = data.quantity || 0;
        this.amount = data.amount && new Amount(data.amount);
        this.isIncludedInRate = data.isIncludedInRate || false;
        this.packageRateBookableProducts = data.packageRateBookableProducts;
        this.packageRatePlanProduct = data.packageRatePlanProduct;
        this.total = data.total;
        this.isV2 = data.isV2;
    }
}

export class Comment {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data = {}) {
        this.requestType = data.requestType || undefined;
        this.requestContent = data.requestContent || undefined;
    }
}